"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const cargoLosses_class_1 = require("./cargoLosses.class");
const insuranceLimits_class_1 = require("./insuranceLimits.class");
class VerifyDetails {
    constructor(data) {
        this.losses = data.losses;
        this.limitsOfInsurance = data.limitsOfInsurance;
    }
    static empty() {
        const data = {
            losses: cargoLosses_class_1.CargoLosses.empty(),
            limitsOfInsurance: insuranceLimits_class_1.InsuranceLimits.empty()
        };
        return new VerifyDetails(data);
    }
    static fromObj(data) {
        if (!data)
            return VerifyDetails.empty();
        return new VerifyDetails({
            losses: data.losses
                ? cargoLosses_class_1.CargoLosses.fromObj(data.losses)
                : cargoLosses_class_1.CargoLosses.empty(),
            limitsOfInsurance: data.limitsOfInsurance
                ? insuranceLimits_class_1.InsuranceLimits.fromObj(data.limitsOfInsurance)
                : insuranceLimits_class_1.InsuranceLimits.empty()
        });
    }
}
exports.default = VerifyDetails;
//# sourceMappingURL=verifyDetails.class.js.map